import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate , useSearchParams } from 'react-router-dom'
import URL from '../constants/ServerUrl'
import axios from 'axios'
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import { convertDateToAD, convertDateToBS } from '../utils/convertDate'
import { formatDateInAD, formatDateInBS } from '../utils/formatDate'
import SkeletonLoader from './Skeletos'



const CollectMilk = ({ route }) => {
  const [isPickerShow, setIsPickerShow] = useState(false)
  const [date, setDate] =  useState(convertDateToBS(Date.now()))
  const [tableData, setTableDate] = useState([])
  const [search, setSearch] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigator = useNavigate()
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const currentDate = new Date();
const selectOption = currentDate.getHours() < 12 ? 'Morning' : 'Evening'; 
const [selectedOption, setSelectedOption] = useState(selectOption);
  const [totalMilk, setTotalMilk] = useState(0)
  const [avgFat, setAvgFat] = useState(0)
  const [avgSNF, setAvgSNF] = useState(0)
  const token = localStorage.getItem("dairy-token")


  const tableHead = useMemo(() => [
    { label: '#', },
    { label: 'Id', },
    { label: 'Name',},
    { label: 'Qty',  },
    { label: 'Fat',  },
    { label: 'Snf',  },
    { label: 'Amt',  },
    {label : 'Operations'}
  ], []);
  
  const tableHeadWidthArr = useMemo(() => tableHead.map((header) => header.width), [tableHead]);
  
  const fetchCollections = async () => {
    try {
      if (username) {
        setIsLoading(true)
        let datec=convertDateToAD(date)
        const collections = await axios.get(
          `${URL}admin/${username}/collection?date=${datec}&shift=${selectedOption}`,{
            Authorization: `Bearer ${token}`,
          }
        )
        const res = await axios.get(
          `${URL}admin/${username}/report/?date=${datec}&shift=${selectedOption}`,{
            Authorization: `Bearer ${token}`,
          }
        )
        setTotalMilk(res.data?.totalMilk || 0)
        setAvgFat(res.data?.avgFat || 0)
        setAvgSNF(res.data?.avgSNF || 0)
        setTableDate(collections.data)
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }

  // refresh control
  const [refreshing, setRefreshing] = useState(false)

  useEffect(() => {
    fetchCollections()
  }, [date, selectedOption])

  const showPicker = () => {
    setIsPickerShow(true);
  };

  const hidePicker = () => {
    setIsPickerShow(false);
  };

  const onChange = ( date) => {
    setDate(date)
  }



  // just to avoid error caused by unserialized date object
  const navigateToAddCollection = () => {
    const dateStringToPass = convertDateToAD(date);
    console.log(date);
    console.log(dateStringToPass);
    navigator(`AddCollection?dateString=${dateStringToPass}&username=${username}&shift=${selectedOption}`)
  }

  const onRefresh = () => {
    setRefreshing(true);
    fetchCollections().then(() => setRefreshing(false));
  };
  const renderTableHeader = () => {
    return tableHead.map((header, index) => (
      <th key={index} className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
        {header.label}
      </th>
    ));
  };
  
  const renderTableRows = () => {
    return tableData
      .filter(({ farmerName }) => farmerName.toLowerCase().startsWith(search.toLowerCase()))
      .map((item, index) => (
        <tr key={index}>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900">{index + 1}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-500">{item.farmerId}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-500">{item.farmerName}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-500">{item.qty}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-500">{item.fat}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-500">{item.snf}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-500">{item.amount}</td>
          <td  className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-500"> 
          <button
      className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded inline-block mb-4"
      onClick={() => {
        const dateStringToPass = formatDateInAD(date);
        console.log(dateStringToPass);
        navigator(`EditCollection?username=${username}&Id=${item._id}`);
      }}
    >
      Edit
    </button>
          </td>
         
        </tr>
      ));
  };
  

  const Item = ({ farmerName, farmerId, qty, rate, fat, snf, amount, id }) => (
<>
  <div className="p-4 border border-gray-300 rounded-md shadow-md bg-white">
    <button
      className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded inline-block mb-4"
      onClick={() => {
        const dateStringToPass = formatDateInAD(date);
        console.log(dateStringToPass);
        navigator(`EditCollection?username=${username}&Id=${id}`);
      }}
    >
      Edit
    </button>
    <div className="mb-4">
      <div className="text-xl font-semibold">{farmerId}</div>
      <div className="text-base">{farmerName}</div>
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div>Qty: {qty}</div>
      <div>Fat: {fat}</div>
      <div>SNF: {snf}</div>
      <div>Amount: {amount}</div>
    </div>
  </div>
</>

  )

  return (
<div className="p-4 font-sans">
  <div className="flex items-center justify-between mb-4">
    <div className="flex items-center w-full">
      <input
        className="border border-gray-300 rounded-md py-2 px-4 w-64 focus:outline-none focus:ring focus:border-blue-500 mr-4"
        placeholder="Search by name"
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        value={search}
        type="text"
      />
      <button
        className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded"
        onClick={() => navigateToAddCollection()}
      >
        Add Collection
      </button>
    </div>
  </div>

  <div className="flex items-center mb-4">
    <div className="flex items-center">
    <div className="flex items-center">
      <button
        className={`font-bold py-2 px-4 rounded mr-4 ${
          isPickerShow ? 'bg-green-500' : 'bg-gray-500 hover:bg-gray-600'
        } text-white`}
        onClick={isPickerShow ? hidePicker : showPicker}
      >
        {isPickerShow ? 'Close Picker' : 'Choose Date'}
      </button>
    </div>

    {isPickerShow && (
      <NepaliDatePicker
        value={date}
        onChange={onChange}
        options={{ calenderLocale: 'en', valueLocale: 'en' }}
      />
    )}

<div className="flex items-center">
  <button
    className={`font-bold py-2 px-4 rounded mr-4 ${
      selectedOption === 'Morning' ? 'bg-red-600' : 'bg-white hover:bg-yellow-600'
    } text-black font-extrabold`}
    onClick={() => setSelectedOption('Morning')}
  >
    Choose Morning
  </button>
</div>

<div className="flex items-center">
  <button
    className={`font-bold py-2 px-4 rounded mr-4 ${
      selectedOption === 'Evening' ? 'bg-red-600' : 'bg-white hover:bg-blue-600'
    } text-black font-extrabold`}
    onClick={() => setSelectedOption('Evening')}
  >
    Choose Night
  </button>
</div>

    </div>
  </div>

  <div className="grid grid-cols-3 gap-4 mb-4">
    <div className="text-center">
      <div className="font-bold">Total Milk</div>
      <div>{totalMilk}</div>
    </div>
    <div className="text-center">
      <div className="font-bold">Avg Fat</div>
      <div>{avgFat}</div>
    </div>
    <div className="text-center">
      <div className="font-bold">Avg SNF</div>
      <div>{avgSNF}</div>
    </div>
  </div>

  <div className="mb-4">
    <row
      className="flex" // Assuming this is a custom component or needs specific styling
      data={tableHead.map((header) => header.label)}
      widthArr={tableHeadWidthArr}
      text
    />
    {isLoading ? (
      <SkeletonLoader />
    ) : tableData.length === 0 ? (
      <div className="text-center">
        <div className="font-bold">No Collections Found</div>
      </div>
    ) : (
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    {renderTableHeader()}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {renderTableRows()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>

 
</div>

  )
}


export default CollectMilk